export default function CentreApi({ makeRequest, buildRequest, baseUrl = '' }) {
    
    function getCentres() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`${baseUrl}/centres`));
        });
    }

    function syncCentre(eceKey) {
        return buildRequest().then(function (req) {
            return makeRequest(req.put(`${baseUrl}/sync/${eceKey}`));
        });
    }

   
    return {
        getCentres,
        syncCentre
    }

}